import(/* webpackMode: "eager" */ "/codebuild/output/src2164447088/src/github.com/bitstone/offerz-nextjs/node_modules/@mui/material/Box/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2164447088/src/github.com/bitstone/offerz-nextjs/node_modules/@mui/material/CircularProgress/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2164447088/src/github.com/bitstone/offerz-nextjs/src/app/[lang]/stylesheet.css");
